import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '../../../utils';
import ContentEditor from '../../ContentEditor';
import NodeActivityEditor from '../../NodeActivityEditor';
import HeaderToolbar from './HeaderToolbar';
import SecondaryButton from '../../SecondaryButton';
import PrimaryButton from '../../PrimaryButton';
import { ViewSection, HeaderUserImage, HeaderUserName, AutoSaveStatus, LockInfo } from '../styles';
import { EditorHeaderRowLeft, EditorHeaderRowRight } from '../../NodeActivityEditor/styles';

const TaskContentViewer = ({
  type,
  report,
  isEditable,
  saveReport,
  user,
  fileService,
  integrations,
  autoSaveStatus,
  isTeacher,
  participations = [],
}) => {
  const isLocked = report?.locked;

  const [showToolbar, setShowToolbar] = useState(false);
  const { full_name, image = {}, id } = user || {};
  const headerTextKey = type === 'group' ? 'group_task_header' : 'app_student_editor';
  const headerName = type === 'group' ? '' : full_name;
  const buttonTextKey = type === 'group' ? 'app_save_complete_group' : 'app_handin';

  const onChangeReport = (value) => {
    saveReport({ ...report, body: value, draft: true });
  };

  const submitReport = () => {
    saveReport({ ...report, state: 'done', draft: false });
  };

  const revokeReport = () => {
    saveReport({ ...report, state: 'active', draft: true });
  };

  if (!report && type === 'group' && !isTeacher) {
    return (
      <ViewSection>
        <p>
          <i>{i18n.__('group_user_not_in_group')}</i>
        </p>
      </ViewSection>
    );
  }

  const headerUser = (id, image, title) => {
    return <HeaderUserImage key={id} src={getImageUrl(fileService, image, '60x60')} title={title} />;
  };

  const studentImages =
    type === 'group' ? (
      <>
        {participations.map((user) => {
          const { full_name, image, id } = user;
          return headerUser(id, image, full_name);
        })}
      </>
    ) : (
      headerUser(id, image, full_name)
    );

  const headerPanel = (
    <>
      <EditorHeaderRowLeft>
        {!isTeacher && studentImages}
        <HeaderUserName>{isTeacher ? i18n.__(headerTextKey) : headerName}</HeaderUserName>
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight>
        <HeaderToolbar
          isEditable={isEditable}
          report={report}
          isTeacher={isTeacher}
          showToolbar={showToolbar}
          setShowToolbar={setShowToolbar}
        />
      </EditorHeaderRowRight>
    </>
  );

  const editorPanel = (
    <ContentEditor
      type={type}
      value={report?.body || ''}
      onChange={(value) => isEditable && onChangeReport(value)}
      integrations={integrations}
      fileService={fileService}
      disabled={!isEditable || isTeacher}
      showToolbar={showToolbar}
      memoize={true}
    />
  );

  const buttonPanel = !isTeacher && (
    <>
      <AutoSaveStatus>{autoSaveStatus['contentEditor']}</AutoSaveStatus>
      {isLocked ? (
        <LockInfo>{i18n.__('editor_locked_desc')}</LockInfo>
      ) : isEditable ? (
        <SecondaryButton text={i18n.__(buttonTextKey)} onClick={submitReport} />
      ) : (
        <PrimaryButton text={i18n.__('app_edit')} onClick={revokeReport} />
      )}
    </>
  );

  return (
    <ViewSection>
      <NodeActivityEditor type={type} headerPanel={headerPanel} editorPanel={editorPanel} buttonPanel={buttonPanel} />
    </ViewSection>
  );
};

export default TaskContentViewer;

TaskContentViewer.propTypes = {
  type: PropTypes.string.isRequired,
  report: PropTypes.object,
  isEditable: PropTypes.bool.isRequired,
  saveReport: PropTypes.func.isRequired,
  user: PropTypes.object,
  fileService: PropTypes.object.isRequired,
  integrations: PropTypes.object.isRequired,
  autoSaveStatus: PropTypes.object.isRequired,
  isTeacher: PropTypes.bool.isRequired,
  participations: PropTypes.array.isRequired,
};
